if($('.owl-carousel.headerslider').length > 0){
$('.owl-carousel.headerslider').owlCarousel({
    loop:true,
    margin:10,
    nav:false,
    dots:false,
    items:1,
  touchDrag  : false,
     mouseDrag  : false,
  autoplay: true,
 autoplayTimeout: 6000,
  autoplayHoverPause: true
    
});
}
if($('.owl-carousel.home-slider--list').length > 0){
$('.owl-carousel.home-slider--list').owlCarousel({
    
    margin:0,
    nav:false,
    dots:true,
    items:1,
  touchDrag  : true,
     mouseDrag  : true,
  autoplay:true,
 autoplayTimeout: 6000,
  loop: true,
 animateIn: 'fadeIn',
    animateOut: 'fadeOut',
rewind: true
    
});
}
$(document).ready(function(){
  $(document).on("click",".cc-custom__btn,.filter-close-custom-popup",function(){
      $(".filter-custom-popup-bg").toggleClass("is-open") ; 
        $(".filter-custom-popup-box").toggleClass("is-open") ; 
  });
  $(document).on("click",".layoutview",function(){
    $(".layoutview").removeClass("active");
    $(this).addClass("active");
    $(".listitemview").removeClass("listview");
    $(".listitemview").removeClass("gridview");
    $(".listitemview").addClass($(this).attr("data"));
  })
});

  function timeAgo(datetime) {
  const now = new Date();
  const date = new Date(datetime);
  const secondsAgo = Math.floor((now - date) / 1000);

  // Time intervals in seconds
  const intervals = [
    { label: 'year', seconds: 31536000 },
    { label: 'month', seconds: 2592000 },
    { label: 'week', seconds: 604800 },
    { label: 'day', seconds: 86400 },
    { label: 'hour', seconds: 3600 },
    { label: 'minute', seconds: 60 },
    { label: 'second', seconds: 1 }
  ];

  // Find the appropriate interval
  for (let interval of intervals) {
    const count = Math.floor(secondsAgo / interval.seconds);
    if (count >= 1) {
      return `${count} ${interval.label}${count > 1 ? 's' : ''} ago`;
    }
  }

  return 'just now'; // for cases where the time difference is less than a second
}
  window.onload = function() {
    if(document.getElementById("custom-reviews")){
  // Define the API endpoint
  const apiEndpoint = "https://cdn.fera.ai/api/v3/public/reviews.json?client=fjs-3.3.5&api_key=pk_aeeed34dae7db167def9119e3f8a56fecac81349b2e045ddba1dfc4fea61211f&page_size=10&sort_by=created_at%3Adesc&include_aggregate_rating=true&offset=0&limit=10";

  // Make an AJAX call using the Fetch API
  fetch(apiEndpoint)
    .then(response => {
      if (!response.ok) {
        throw new Error("Network response was not ok " + response.statusText);
      }
      return response.json();
    })
    .then(data => {
      // Handle the data from the API
      var htmlData = '<div class="owl-carousel owl-theme review-slider--list">';
      data.data.forEach(element=>{
        htmlData += '<div data-id="'+element.id+'" tabindex="-1" class="fera-review fera-review--for-product">         <div class="fera-review-content">         <div class="fera-review-ratingAndDate"><div class="fera-review-rating fera-stars" data-fera-component="stars" data-rating="'+element.rating+'" style="position: relative;">     <span class="fera--srOnly" style="position: absolute; top: 0; opacity: 0;">'+element.rating+'</span>     <span class="fera-stars-bg"><b>★</b><b>★</b><b>★</b><b>★</b><b>★</b></span>     <span class="fera-stars-rating" style="position: absolute; top: 0px; left: 0px; width: 115px;" data-fera-stars=""><b>★</b><b>★</b><b>★</b><b>★</b><b>★</b></span> </div><div data-fera-component="date" class="fera-review-date">     <meta content="'+element.created_at+'">     <span class="fera-review-date-val fera-timeAgo" data-fera-component="timeAgo" data-value="'+element.created_at+'" data-timestamp="1729257761241">'+timeAgo(element.created_at)+'</span> </div></div>         <div data-fera-component="heading" class="fera-review-heading">'+element.heading+'</div>         <div data-fera-component="body" data-max-length="72" class="fera-truncatedText fera-truncatedText--full fera-review-body">'+element.body+'</div>         <div data-fera-component="customerName" class="fera-customer-display-name">     <div class="fera-customer-display-name-text fera-customer-display-name-text--with-flare">         <span data-fera-name-text="" class="fera--clickable">'+element.customer?.display_name+'</span>     </div>     <div data-fera-component="flare" class="fera-customer-flare"></div> </div>             </div>'; 
if(typeof element.product?.name !== 'undefined'){
     htmlData += '<div data-fera-component="product" data-max-name-length="15" data-fera-product="'+element.id+'" class="fera-review-product"><a href="'+element.product?.url+'" class="fera-review-product-link">             <div class="fera-review-product-image-container" data-fera-product-img-container=""><img src="'+element.product?.thumbnail_url+'" alt="Image of product reviewed" loading="lazy" data-fera-product-img="" class="fera-review-product-img"></div>             <div class="fera-review-product-text-container">                 <div class="fera-review-product-link-caption">View product</div><div class="fera-review-product-name-prefix">Product:&nbsp;</div><!-- added to avoid extra spacing             --><div class="fera-review-product-name fera-truncatedText" data-fera-component="productName">     <div class="fera-truncatedText--truncated">'+element.product?.name+'</div>     <div class="fera-truncatedText--full fera-hidden">'+element.product?.name+'</div> </div>             </div>             <div class="fera-review-product-caret-container" data-fera-component-container="caret"><svg class="fera-icon fera-icon-caret fera-icon-caret--right" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">     <title>right</title>     <path d="M9 6.75L14.25 12L9 17.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </svg></div>         </a></div> ';
}
	 htmlData += '</div>';
      })
      document.getElementById("custom-reviews").innerHTML = htmlData+"</div>";
      if($('.owl-carousel.review-slider--list').length > 0){
      $('.owl-carousel.review-slider--list').owlCarousel({
          
          margin:0,
          nav:true,
          dots:true,
      slideBy: 2,
        touchDrag  : true,
           mouseDrag  : true,
         
        loop: true,
       animateIn: 'fadeIn',
          animateOut: 'fadeOut',
      rewind: true,
        responsive: {
    0: {
      items: 1 
    },

    600: {
      items: 1
    },

    1024: {
      items: 2
    },
        }
          
      });
      }
      // Perform any additional processing here
    })
    .catch(error => {
      // Handle any errors
      console.error("There was a problem with the fetch operation:", error);
    });
    }
};